export enum ScheduleSaveStep {
  CONFIRM = 'CONFIRM',
  SAVING = 'SAVING',
  SUMMARY = 'SUMMARY',
}
